<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M42 24.44C42 13.46 33.48 6 24 6C14.62 6 6 13.3 6 24.56C4.8 25.24 4 26.52 4 28V32C4 34.2 5.8 36 8 36H10V23.8C10 16.06 16.26 9.8 24 9.8C31.74 9.8 38 16.06 38 23.8V38H22V42H38C40.2 42 42 40.2 42 38V35.56C43.18 34.94 44 33.72 44 32.28V27.68C44 26.28 43.18 25.06 42 24.44Z"
            fill="currentColor" />
        <path
            d="M18 28C19.1046 28 20 27.1046 20 26C20 24.8954 19.1046 24 18 24C16.8954 24 16 24.8954 16 26C16 27.1046 16.8954 28 18 28Z"
            fill="currentColor" />
        <path
            d="M30 28C31.1046 28 32 27.1046 32 26C32 24.8954 31.1046 24 30 24C28.8954 24 28 24.8954 28 26C28 27.1046 28.8954 28 30 28Z"
            fill="currentColor" />
        <path
            d="M36 22.06C35.04 16.36 30.08 12 24.1 12C18.04 12 11.52 17.02 12.04 24.9C16.98 22.88 20.7 18.48 21.76 13.12C24.38 18.38 29.76 22 36 22.06Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
